export default {
  "loading": "Cargando",
  "feedbackMessages": {
    "badNps": {
      "message1": "Gracias por tu opinión",
      "message2": "¡Vamos a mejorar!"
    },
    "regularNps": {
      "message1": "Gracias por tu opinión",
      "message2": "¡Seguiremos mejorando!"
    },
    "goodNps": {
      "message1": "Muchas gracias por tu opinión",
      "message2": "¡Es muy importante para nosotros!"
    },
    "error": {
      "message1": "Ha ocurrido un error",
      "message2": "Intente actualizar para intertar nuevamente"
    }
  },
  "disclaimer": "Esta encuesta no es anónima, lo que nos permitirá contactarte para recibir tus comentarios y sugerencias."
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/survey/index.js